// src/pages/Home.js
import { Link } from 'react-router-dom';
import { posts } from '../data/posts';
import Footer from '../components/footer';




const ComingSoon = () => (
  <>
    <style>
      {`
        .coming-soon-container {
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f4f4f4;
          font-family: sans-serif;
        }

        .coming-soon-text {
          font-size: 3rem;
          color: #333;
        }

        .dots::after {
          content: '';
          display: inline-block;
          width: 1em;
          text-align: left;
          animation: dots 1.5s steps(3, end) infinite;
        }

        @keyframes dots {
          0%   { content: ''; }
          33%  { content: '.'; }
          66%  { content: '..'; }
          100% { content: '...'; }
        }
      `}
    </style>
    <div className="coming-soon-container">
      <h1 className="coming-soon-text">
        Coming Soon<span className="dots" />
      </h1>
    </div>
  </>
);




















const Home = () => {
  const panelStyle = {
    //backgroundColor: '#ffe600', // vibrant comic-style yellow
    border: '3px solid #000',
    padding: '20px',
    margin: '20px 0',
    borderRadius: '8px',
    boxShadow: '5px 5px 0 #000',
    transition: 'transform 0.2s ease',
    fontFamily: 'Comic Sans MS, Arial, sans-serif',
  };

  const linkStyle = {
    textDecoration: 'none',
    color: '#000',
    fontWeight: 'bold',
    fontSize: '1.3rem',
  };

  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    background: 'linear-gradient(to bottom, #f0f8ff, #cce0f0)',
    borderRadius : '5rem'
  };

  return (
    <div style={containerStyle}>
      <h1>Wise Wealth</h1>
      <h2 style={{ fontStyle: 'italic' }}>“Smart Moves. Real Growth. Build Your Legacy."</h2>
      <br></br>
      <ul style={{ padding: 0 }}>
        <h2>Investement Article</h2>
        {posts.map((post) => (
          <li key={post.slug} style={{ listStyleType: 'none' }}>
<Link to={`/${post.slug}`} style={{ textDecoration: 'none' }}>
  <div
    style={{
      ...panelStyle,
      cursor: 'pointer',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.02)';
      e.currentTarget.style.backgroundColor = '#d0e7fa'; // subtle hover color
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.backgroundColor = '#e0f0ff'; // normal color
    }}
  >
    <span style={linkStyle}>{post.title}</span>
  </div>
</Link>

          </li>
        ))}
      </ul>
      <br></br>
      <h2>Side Hustle to get your first 100k</h2>
      <div style={panelStyle}><b>Coming soon ...</b></div>
      <br />
      <p>
        <b>What is this blog about:</b>
        <br />
        <br />
        Welcome to <b>Wise Wealth</b>, where we break down the financial game in a way anyone can
        understand. We’re talking real strategies—how to turn a couple hundred bucks into{' '}
        <b>thousands</b>, get your debt under control, and make <b>smart moves</b> with stocks and
        crypto. This isn’t just about saving <b>pennies</b>, it’s about building{' '}
        <b style={{ color: 'red' }}>real wealth</b> and creating a future you can be proud of.
        Whether you’re starting from the bottom or leveling up, we’re here to help you make your
        next move the right one.
      </p>
      <Footer />
    </div>
  );
};

export default Home;
